export default "__VITE_ASSET__ffcf107d__"